import { render, staticRenderFns } from "./CompanyEditSubscriptionModuleMetaDataMaxDocuments.vue?vue&type=template&id=5034cba1&"
import script from "./CompanyEditSubscriptionModuleMetaDataMaxDocuments.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditSubscriptionModuleMetaDataMaxDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5034cba1')) {
      api.createRecord('5034cba1', component.options)
    } else {
      api.reload('5034cba1', component.options)
    }
    module.hot.accept("./CompanyEditSubscriptionModuleMetaDataMaxDocuments.vue?vue&type=template&id=5034cba1&", function () {
      api.rerender('5034cba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditSubscriptionModuleMetaDataMaxDocuments.vue"
export default component.exports